<template>
	<div class="p-col-12">
		<template v-if="commonService.isMobile()">
			<div class="p-col-12" style="display: flex; margin-top: -15px;">
				<img :src="commonService.getTirolibreIconUrl()" @click="toHome" alt="Tirolibre" class="logo-width">
				<span class="brand-text">TiroLibre - Transfer Market Platform</span>
			</div>
			<div class="p-col-12 p-grid" style="border-bottom: 1px solid grey; margin-top: -15px; margin-bottom: 15px;">
				<hr />
			</div>
		</template>
		<template v-else>
			<div class="p-col-12 p-grid" style="margin-top: -35px;">
				<div class="p-col-9" style="display: flex; margin: auto">
					<img :src="commonService.getTirolibreIconUrl()" @click="toHome" alt="Tirolibre" style="cursor: pointer; vertical-align: middle; width: 5%; margin-left: 30px; border-radius: 50%;">
					<span class="brand-text">TiroLibre - Transfer Market Platform</span>
				</div>
				<div class="p-col-1" style="margin: auto">
					<Button label="Log in" class="p-button-warning" style="background-color: white; border: 0px solid; font-weight: bold;" @click="toLogin" />
				</div>
				<div class="p-col-1 p-md-2" style="margin: auto">
					<Button label="Sign up" class="p-button-warning" style="color: white; font-weight: bold; width: 70%;" @click="toRegister" />
				</div>
				<div class="p-col-1">
				</div>
			</div>
			<div class="p-col-12 p-grid" style="margin-top: -35px; border-bottom: 1px solid grey;">
				<hr />
			</div>
		</template>

	</div>
</template>

<script>
import CommonService from "@/service/CommonService";

export default {
	commonService: null,
	created() {
		this.commonService = new CommonService();
	},
	methods: {
		toLogin() {
			this.$router.push("/login");
		},
		toRegister() {
			this.$router.push("/register");
		},
		toHome() {
			this.$router.push("/home");
		},
	},
};
</script>

<style scoped>
.brand-text {
	font-size: 20px;
	font-weight: bold;
	margin: auto 30px;
}

.logo-width {
	width: 25%;
	border-radius: 50%;
}

@media (min-width: 0px) and (max-width: 1000px) {
	.brand-text {
		font-size: 15px;
		font-weight: bold;
		margin: auto 15px;
	}

	.logo-width {
		width: 15%;
	}
}
</style>